import { BackUrlType, BackUrlTypes } from "../types/back-url";

export const setBackUrl = (payload: string): BackUrlType => ({
  type: BackUrlTypes.BACK_URL,
  payload,
});
